import PageHero from "../../components/sections/PageHero";
import GoldButton from "../../components/ui/GoldButton";
import SectionLabel from "../../components/ui/SectionLabel";

const Mumbai = () => (
  <>
    <PageHero
      label="MUMBAI"
      title="Mumbai's"
      titleAccent="technology partner."
      subtitle="Serving businesses across Mumbai with structured remote delivery. Headquartered in Delhi, India with international execution standards."
    />

    <section style={{ background: "#050505", padding: "0 0 120px" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 clamp(20px, 4vw, 48px)" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 24, marginBottom: 36 }}>
          <div style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: 28 }}>
            <SectionLabel text="MUMBAI BUSINESSES" />
            <p style={{ marginTop: 16, fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#F8F4EC", lineHeight: 1.85 }}>
              Financial services in BKC · Real estate in South Mumbai · Law firms on Marine Lines/Fort · D2C brands in Dharavi/Kurla · Restaurants in Bandra/Juhu · Manufacturing in Thane/Bhiwandi
            </p>
          </div>
          <div style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: 28 }}>
            <SectionLabel text="TOP REQUESTED" />
            <p style={{ marginTop: 16, fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#F8F4EC", lineHeight: 1.85 }}>
              Law Firm CRM & LegalTech · Real Estate CRM & Lead Systems · D2C E-Commerce & Marketing · Financial Services Software · AI Call Centre for NBFC/Insurance
            </p>
          </div>
        </div>

        <div style={{ textAlign: "center" }}>
          <GoldButton href="/contact">SCHEDULE A MUMBAI CONSULTATION</GoldButton>
        </div>
      </div>
    </section>
  </>
);

export default Mumbai;
